import axios from "axios";
import { LOGOUT_URL } from "./URLS";

const SIGN_OUT_REDIRECT = "https://www.shenlaroche.com/";

/**
 * Delete the server DRF token (best effort), clear local session, redirect.
 */
export async function signOut({ setUser } = {}) {
  const token = localStorage.getItem("token");
  try {
    if (token) {
      await axios.post(
        LOGOUT_URL,
        {},
        { headers: { Authorization: `Token ${token}` } },
      );
    }
  } catch (_) {
    // Still clear local session if token already expired or network failed.
  }
  localStorage.removeItem("token");
  localStorage.removeItem("email");
  if (typeof setUser === "function") {
    setUser(null);
  }
  window.location.href = SIGN_OUT_REDIRECT;
}
